const User = {

    // SECTIONS
    "basic_info": "Basic Info",
    "address_info": "Address Info",
    "other_info": "Other Info",

    // FIELDS
    "role": "Role",
    "user_type": "User Type",
    "fname": "First Name",
    "lname": "Last Name",
    "gender": "Gender",
    "password": "Password",
    "confirm_password": "Confirm Password",
    "mobile": "Mobile Number",
    "email": "Email",
    "country": "Country",
    "state": "State",
    "city": "City",
    "pincode": "Pincode",
    "address": "Address",
    "profile": "Profile Photo",
    "dob": "Date of Birth",
    "status": "Status",

    // PAGE HEADER
    "user": "User",
    "search": "Search",
    "details_error": "Something went wrong, can't load user details",

    // TABLE HEADERS
    "table_name": "NAME",
    "table_email": "EMAIL",
    "table_mobile": "MOBILE",
    "table_role": "ROLE",
    "table_gender": "GENDER",
    "table_status": "STATUS",

    // ERROR MESSAGES
    "error_role": "Select Role",
    "error_user_type": "Select User Type",
    "error_fname": "Enter First Name",
    "error_lname": "Enter Last Name",
    "error_gender": "Select Gender",
    "error_password": "Enter Password",
    "error_confirm_password": "Enter Confirm Password",
    "error_password_match": "Confirm Password doesn't match",
    "error_mobile": "Enter Mobile Number",
    "error_invalid_mobile": "Invalid Mobile Number (10 digits required)",
    "error_email": "Enter Email",
    "error_invalid_email": "Invalid Email Address",
    "error_pincode": "Enter Valid Pincode",
    "error_file_size": "File size must be less than 5MB",
    "error_file_type": "Only JPG, JPEG, PNG images are allowed",
    "error_dob": "Select Date of Birth",
    "error_status": "Select Status",

}

export default User;